import { useState } from 'react';
import { Header } from './ui';
import { IntroScreen } from './screens/IntroScreen';
import { StepsScreen } from './screens/StepsScreen';

type ScreenName = 'intro' | 'steps';

export function Wizard() {
  const [screen, setScreen] = useState<ScreenName>('intro');

  return (
    <div className="relative h-screen w-full bg-white">
      <Header onClose={() => setScreen('intro')} />
      {screen === 'intro' && <IntroScreen onStart={() => setScreen('steps')} />}
      {screen === 'steps' && <StepsScreen onComplete={() => setScreen('intro')} />}
    </div>
  );
}
